/**
 * DisplayHeadline — Cormorant display headline with gold-italic <em> accents.
 * Any <em> child is automatically painted in champagne-gold serif italic.
 *
 * @example
 *   <DisplayHeadline>One quiet room for the whole <em>craft</em>.</DisplayHeadline>
 *
 *   <DisplayHeadline as="h2" size="section" align="center" tone="charcoal">
 *     A studio worth <em>arriving</em> to.
 *   </DisplayHeadline>
 */
import React from "react";

const SIZE = {
  cover:   "ed-display",
  hero:    "ed-hero",
  section: "ed-headline",
  sub:     "ed-subhead",
};

const ALIGN = { left: "text-left", center: "text-center", right: "text-right" };

const TONE = {
  cream:    "text-[color:var(--cream-ink)]",
  charcoal: "text-[color:var(--charcoal-ink)]",
  inherit:  "",
};

export default function DisplayHeadline({
  as: As = "h1",
  size = "hero",
  align = "left",
  tone = "inherit",
  className = "",
  children,
  ...rest
}) {
  return (
    <As
      className={`${SIZE[size] || SIZE.hero} ${ALIGN[align] || ALIGN.left} ${TONE[tone] || ""} ${className}`}
      {...rest}
    >
      {children}
    </As>
  );
}
